export default __webpack_public_path__ + "static/media/78_mobile.50e7434a.jpg";